import * as React from 'react';
import {Typography, WithStyles, withStyles,} from '@material-ui/core';
import {IEcoAgreement, IRespondEcoAgreement, IRespondEcoAgreementUpdate} from "@app-types/websocket/economy.types";
import {IFamilyMember} from "@app-types/websocket/family.types";
import TranslateNew from "@translate/TranslateNew";
import AgreementCard from "@components/economy/AgreementCard";
import { ecoContainerStyle } from './Container.style';

const tn = TranslateNew.getInstance();

interface ISentAgreementsCardProps extends WithStyles<typeof ecoContainerStyle>
{
    agreements: IEcoAgreement[];
    family: IFamilyMember[];
    userId:number;
    currency:string;
    respond: (response:IRespondEcoAgreement) => void;
    respondChange: (response: IRespondEcoAgreementUpdate) => void;
    edit: (agreement:IEcoAgreement) => void;
    seen: (agreementId:number) => void;
    scrollTime:number;
    waitForAgreementChat:(id:number) => void;
}

class ContainerSentAgreements extends React.Component<ISentAgreementsCardProps> {
    public render()
    {
        const { classes, agreements, family, respond,respondChange,waitForAgreementChat } = this.props;

        return (
            <div className={classes.container}>
                <div className={classes.titleWrapper}>
                    <Typography className={classes.heading1} gutterBottom={false}>{tn.lang.purchaseProposalSent}</Typography>
                </div>
                {agreements.map((agreement) => (
                    <AgreementCard key={agreement.id}  edit={() => this.props.edit(agreement)}  scrollTime={this.props.scrollTime}
                        userId={this.props.userId} currency={this.props.currency} seen={this.props.seen} waitForAgreementChat={waitForAgreementChat}
                        agreement={agreement} type="sent" family={family}  respondChange={respondChange} respond={respond} />
                ))}
            </div>
        );
    }
}

export default withStyles(ecoContainerStyle)(ContainerSentAgreements);



// WEBPACK FOOTER //
// ./src/components/economy/ContainerSentAgreements.tsx